/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { ComponentLike } from '@glint/template';

interface CheckboxArgs {
  triggerComponent: ComponentLike<any>;
  disabled: boolean;
  checked: boolean;
}

export default class Checkbox extends Component<CheckboxArgs> {}
